
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#D0EFEC","d":"M39.845 29.258a.5.5 0 0 1 0 1h-8.503a.5.5 0 1 1 0-1zm0-5.668a.5.5 0 0 1 0 1h-8.503a.5.5 0 1 1 0-1z"}}),_c('path',{attrs:{"fill":"#D0EFEC","fill-rule":"evenodd","d":"M9.695 19.57a1 1 0 0 1 1-1H24.4a1 1 0 0 1 1 1v13.702a1 1 0 0 1-1 1h-1.644a6.62 6.62 0 0 0-4.663-5.138 4.235 4.235 0 1 0-3.489-.052 6.62 6.62 0 0 0-4.749 4.731 1 1 0 0 1-.159-.54z","clip-rule":"evenodd"}}),_c('path',{attrs:{"stroke":"#234652","stroke-linecap":"round","d":"M35.427 11.754h6.098c1.328 0 2.404 1.05 2.404 2.345v23.65c0 1.296-1.076 2.346-2.404 2.346H6.656c-1.328 0-2.405-1.05-2.405-2.345V14.1c0-1.296 1.077-2.346 2.405-2.346h6.098m17.588 17.005h8.502m-8.502-5.669h8.502M24.09 33.01a6.54 6.54 0 0 0-2.465-3.06 7.07 7.07 0 0 0-3.856-1.19 7.1 7.1 0 0 0-3.887 1.098 6.56 6.56 0 0 0-2.545 3m9.352-18.27c-1.252 0-2.267-.952-2.267-2.126v-4.25c0-1.175 1.015-2.127 2.267-2.127h6.802c1.253 0 2.268.952 2.268 2.126v4.251c0 1.174-1.015 2.126-2.268 2.126zm.978 9.927a4.194 4.194 0 1 1-8.387 0 4.194 4.194 0 0 1 8.387 0Z"}}),_c('path',{attrs:{"fill":"#D0EFEC","d":"M45.5 38V15a.5.5 0 0 1 1 0v23a4.5 4.5 0 0 1-4.5 4.5H8a.5.5 0 0 1 0-1h34a3.5 3.5 0 0 0 3.5-3.5"}})])
          )
        }
      }
    